module.exports = __webpack_public_path__ + "static/media/1.matboardSizingAndArtworkWindowOptions.75811bca.png";